export const SearchBlockWidth = 420;
